import request from '@/plugins/request/system';

/**
 * 登录管理
 * @param data
 * @constructor
 */
export function SystemLogin (data) {
  return request({
    url: '/systemv1/login/login',
    method: 'post',
    data
  });
}

/**
 * 管理退出登录
 * @param data
 * @constructor
 */
export function SystemLogout (data) {
  return request({
    url: '/systemv1/admin/logout',
    method: 'post',
    data
  });
}




/**
 * 登录管理
 * @param data
 * @constructor
 */
export function SystemGetYzm (data) {
  return request({
    url: '/systemv1/login/yzm',
    method: 'post',
    data
  });
}






// WEBPACK FOOTER //
// ./src/api/system/login.js